import React, { Component } from 'react'

/* Components */
import ScoreboardView from './ScoreboardView'

/* Modules */
import { message } from 'antd'
import { Redirect } from 'react-router-dom'
import { getChamp } from '../../utils/champsFunctions'
import { getARotationFromChamp, getASwitchingFromChamp, updateARotationFromChamp, updateASwitchingFromChamp } from '../../utils/confrontationsFunctions'

class Scoreboard extends Component {

    constructor(props) {
        super(props)
        this.state = {
            champObject: '',
            champId: null,

            competitor01: this.props.location.state.scoreboard.competitor01,
            completeCompetitor01: this.props.location.state.scoreboard.competitor01['allInfo'],
            competitor02: this.props.location.state.scoreboard.competitor02,
            completeCompetitor02: this.props.location.state.scoreboard.competitor02['allInfo'],
            stage: this.props.location.state.scoreboard.stage,
            realStage: this.props.location.state.scoreboard.realStage,
            chave: this.props.location.state.scoreboard.idOfSwitching,
            index: this.props.location.state.scoreboard.index,
            switchingOrRotation: this.props.location.state.scoreboard.switchingOrRotation,
            idOfSwitching: this.props.location.state.scoreboard.idOfSwitching,

            cronMin: 0,
            cronSeg: 0,
            startCron: true,

            loading: false,
            loadginSave: false,

            pageToGo: ''
        }
    }

    componentWillMount = async () => {
        // Get specific champ object
        let arrayOfRoute = this.props.location.pathname.split('/');

        const champId = arrayOfRoute[3];
        const champ = await getChamp(champId);
        this.setState({
            champObject: champ,
            champId: champId,
        });

        this.renderScoreboard(this.props.location.state.scoreboard)
    }

    renderScoreboard = async (props) => {

        this.setState({
            competitor01: props.competitor01,
            completeCompetitor01: props.competitor01['allInfo'],
            competitor02: props.competitor02,
            completeCompetitor02: props.competitor02['allInfo'],
            stage: props.stage,
            chave: props.idOfSwitching,
            realStage: props.realStage,
            index: props.index,
            switchingOrRotation: props.switchingOrRotation,
            startCron: true,
            loading: true,
            idOfSwitching: props.idOfSwitching,
        })

        /* Get the score from firebase */
        if (props.idOfSwitching) {
            let switching;
            if (props.switchingOrRotation === 'switching') switching = await getASwitchingFromChamp(this.state.champId, props.idOfSwitching.toString());
            else switching = await getARotationFromChamp(this.state.champId, props.idOfSwitching.toString());

            if (switching && switching.scoreboard) {
                let localScoreboard = switching.scoreboard
                if (localScoreboard[props.realStage] && localScoreboard[props.realStage][this.state.index]) {
                    this.setState({
                        competitor01: localScoreboard[props.realStage][this.state.index],
                        competitor02: localScoreboard[props.realStage][this.state.index + 1]
                    })
                }
            }

            /* Close Loading Icon */
            this.setState({ loading: false })
        }
    }

    /* Method to score competitor */
    scoreCompetitor = (competitor, pontuacao, score) => {

        if (competitor === 'competitor01') {
            let localCompetitor = this.state.competitor01

            /* Score advantage or punishment */
            if (pontuacao === 'punicoes' && localCompetitor['pontuacao']['punicoes'] === 1) {
                let localCompetitor02 = this.state.competitor02
                if (score === 1)
                    localCompetitor02['pontuacao']['1'] += 1
                else
                    localCompetitor02['pontuacao']['1'] -= 1
                localCompetitor02['pontuacao']['total'] = this.buildTotalScore(localCompetitor02)
                this.setState({ competitor02: localCompetitor02 })
            } else if (pontuacao === 'punicoes' && localCompetitor['pontuacao']['punicoes'] > 1) {
                let localCompetitor02 = this.state.competitor02
                if (score === 1)
                    localCompetitor02['pontuacao']['2'] += 1
                else
                    localCompetitor02['pontuacao']['2'] -= 1
                localCompetitor02['pontuacao']['total'] = this.buildTotalScore(localCompetitor02)
                this.setState({ 'competitor02': localCompetitor02 })
            }

            localCompetitor['pontuacao'][pontuacao] += score
            localCompetitor['pontuacao']['total'] = this.buildTotalScore(localCompetitor)
            this.setState({ competitor01: localCompetitor })


        } else {
            let localCompetitor = this.state.competitor02

            /* Score advantage or punishment */
            if (pontuacao === 'punicoes' && localCompetitor['pontuacao']['punicoes'] === 1) {
                let localCompetitor01 = this.state.competitor01
                if (score === 1)
                    localCompetitor01['pontuacao']['1'] += 1
                else
                    localCompetitor01['pontuacao']['1'] -= 1
                localCompetitor01['pontuacao']['total'] = this.buildTotalScore(localCompetitor01)
                this.setState({ competitor01: localCompetitor01 })
            } else if (pontuacao === 'punicoes' && localCompetitor['pontuacao']['punicoes'] > 1) {
                let localCompetitor01 = this.state.competitor01
                if (score === 1)
                    localCompetitor01['pontuacao']['2'] += 1
                else
                    localCompetitor01['pontuacao']['2'] -= 1
                localCompetitor01['pontuacao']['total'] = this.buildTotalScore(localCompetitor01)
                this.setState({ 'competitor01': localCompetitor01 })
            }

            localCompetitor['pontuacao'][pontuacao] += score
            localCompetitor['pontuacao']['total'] = this.buildTotalScore(localCompetitor)
            this.setState({ competitor02: localCompetitor })
        }

    }

    /* Submethod to build total score */
    buildTotalScore = (competitor) => {
        let total = 0
        total = competitor.pontuacao['2'] * 2 + competitor.pontuacao['3'] * 3 + competitor.pontuacao['4'] * 4
        return total
    }

    /* Go back to confrontations - Show and hide components */
    saveScore = async () => {
        /* Open Loading Icon */
        this.setState({ loadingSave: true })

        /* Put the scores in the firebase */
        let switching;
        if (this.state.switchingOrRotation === 'switching') switching = await getASwitchingFromChamp(this.state.champId, this.state.chave.toString())
        else switching = await getARotationFromChamp(this.state.champId, this.state.chave.toString())

        let localSwitching = switching;

        if (!localSwitching['scoreboard'])
            localSwitching['scoreboard'] = {}

        if (!localSwitching['scoreboard'][this.state.realStage])
            localSwitching['scoreboard'][this.state.realStage] = []

        if (localSwitching['scoreboard'][this.state.realStage].length === 0) {
            let count = 2
            if (this.state.realStage === 'roundOf32')
                count = 32
            else if (this.state.realStage === 'roundOf16')
                count = 16
            else if (this.state.realStage === 'quarterFinals')
                count = 8
            else if (this.state.realStage === 'semiFinals')
                count = 4

            for (let i = 0; i < count; i++) {
                localSwitching['scoreboard'][this.state.realStage][i] = {
                    'nome': localSwitching[this.state.realStage][i].nome,
                    'allInfo': localSwitching[this.state.realStage][i],
                    'pontuacao': { '1': 0, '2': 0, '3': 0, '4': 0, 'punicoes': 0, 'total': 0 }
                }
            }
        }

        localSwitching['scoreboard'][this.state.realStage][this.state.index] = this.state.competitor01
        localSwitching['scoreboard'][this.state.realStage][this.state.index + 1] = this.state.competitor02

        try {
            if (this.state.switchingOrRotation === 'switching') await updateASwitchingFromChamp(this.state.champId, this.state.chave.toString(), localSwitching)
            else await updateARotationFromChamp(this.state.champId, this.state.chave.toString(), localSwitching)

            /* Push the winner in firebase if competitor wasn't finalized */
            if (!this.state.competitor01.hasFinalized && !this.state.competitor02.hasFinalized) {
                if (this.state.competitor01['pontuacao']['total'] > this.state.competitor02['pontuacao']['total'])
                    this.chooseAWinner(this.state.index, this.state.index, this.state.index + 1, this.state.realStage, this.state.completeCompetitor01)
                else if (this.state.competitor02['pontuacao']['total'] > this.state.competitor01['pontuacao']['total'])
                    this.chooseAWinner(this.state.index + 1, this.state.index + 1, this.state.index, this.state.realStage, this.state.completeCompetitor02)
                else {
                    if (this.state.competitor01['pontuacao']['punicoes'] === this.state.competitor02['pontuacao']['punicoes']) {
                        if (this.state.competitor01['pontuacao']['1'] > this.state.competitor02['pontuacao']['1'])
                            this.chooseAWinner(this.state.index, this.state.index, this.state.index + 1, this.state.realStage, this.state.completeCompetitor01)
                        else
                            this.chooseAWinner(this.state.index + 1, this.state.index + 1, this.state.index, this.state.realStage, this.state.completeCompetitor02)
                    } else {
                        if (this.state.competitor01['pontuacao']['punicoes'] < this.state.competitor02['pontuacao']['punicoes'])
                            this.chooseAWinner(this.state.index, this.state.index, this.state.index + 1, this.state.realStage, this.state.completeCompetitor01)
                        else
                            this.chooseAWinner(this.state.index + 1, this.state.index + 1, this.state.index, this.state.realStage, this.state.completeCompetitor02)
                    }
                }
            }
            /* Push the winner in firebase if competitor 01 finalized */
            else if (this.state.competitor01.hasFinalized) {
                this.chooseAWinner(this.state.index, this.state.index, this.state.index + 1, this.state.realStage, this.state.completeCompetitor01)
            }
            /* Push the winner in firebase if competitor 02 finalized */
            else if (this.state.competitor02.hasFinalized) {
                this.chooseAWinner(this.state.index + 1, this.state.index + 1, this.state.index, this.state.realStage, this.state.completeCompetitor02)
            }

            /* Close Loading Icon */
            this.setState({ loadingSave: false })
            message.success('Placar salvo com sucesso!')
            // })
        } catch (err) {
            /* Close Loading Icon */
            this.setState({ loadingSave: false })
            message.error('Erro ao salvar o placar')
        };
    }

    /* Invert competitor in the scoreboard */
    invertCompetitor = () => {
        let localCompetitor = this.state.competitor01
        localCompetitor['isInverted'] ? localCompetitor['isInverted'] = false : localCompetitor['isInverted'] = true
        this.setState({ competitor01: localCompetitor })
    }

    /**
     * Methods to choose a winner
     */
    chooseAWinner = async (index, keyWinner, keyLose, stage, competitor) => {
        /* Find the next stage */
        let nextStage = ''
        if (stage === 'roundOf32')
            nextStage = 'roundOf16'
        else if (stage === 'roundOf16')
            nextStage = 'quarterFinals'
        else if (stage === 'quarterFinals')
            nextStage = 'semiFinals'
        else if (stage === 'semiFinals')
            nextStage = 'final'

        if (this.state.switchingOrRotation === 'switching') {

            /* Get and Set in a variable all switching infos */
            let localSwitching = await getASwitchingFromChamp(this.state.champId, this.state.chave.toString());

            /* Update the local winner */
            if (stage === 'final') {
                localSwitching[stage][keyWinner]['hasWon'] = true
                localSwitching[stage][keyWinner]['score'] = 9
            } else {
                localSwitching[stage][keyWinner]['hasWon'] = true
            }

            /* Update the local lose */
            if (stage === 'final') {
                localSwitching[stage][keyLose]['hasWon'] = false
                localSwitching[stage][keyLose]['lostTo'] = competitor.__key
                localSwitching[stage][keyLose]['score'] = 3
            } else {
                localSwitching[stage][keyLose]['hasWon'] = false
                localSwitching[stage][keyLose]['lostTo'] = competitor.__key
            }

            /* Send winner to the next stage */
            /* First: Create a competitor with the basic infos */
            let localCompetitor = {
                __key: competitor.__key,
                apto: competitor.apto,
                equipe: competitor.equipe,
                faixa: competitor.faixa,
                idade: competitor.idade,
                nome: competitor.nome,
                peso: competitor.peso,
                pesoQtd: competitor.pesoQtd,
                sexo: competitor.sexo,
                wasDeleted: competitor.wasDeleted
            }
            /* Second: Push competitor in next stage */
            let localIndexOfNextStage = index
            if (nextStage !== '') {
                if (nextStage === 'final') {
                    if (index === 0 || index === 1)
                        localIndexOfNextStage = 0
                    else
                        localIndexOfNextStage = 1
                } else if (nextStage === 'roundOf16') {
                    if (index % 2 === 0)
                        localIndexOfNextStage = ((localIndexOfNextStage + 2) / 2) - 1
                    else
                        localIndexOfNextStage = ((localIndexOfNextStage + 1) / 2) - 1
                } else {
                    if (index % 2 === 0) {
                        if (index === 0 || index === 8 || index === 6 || index === 14)
                            localIndexOfNextStage = ((localIndexOfNextStage + 2) / 2) - 1
                        else if (index === 2 || index === 10)
                            localIndexOfNextStage = ((localIndexOfNextStage + 2) / 2)
                        else
                            localIndexOfNextStage = (localIndexOfNextStage / 2) - 1
                    }
                    else {
                        if (index === 1 || index === 7 || index === 9 || index === 15)
                            localIndexOfNextStage = ((localIndexOfNextStage + 1) / 2) - 1
                        else if (index === 3 || index === 11)
                            localIndexOfNextStage = ((localIndexOfNextStage + 1) / 2)
                        else
                            localIndexOfNextStage = ((localIndexOfNextStage - 1) / 2) - 1
                    }
                }

                /* Update the local winner to next stage */
                localSwitching[nextStage][localIndexOfNextStage] = Object.assign(localSwitching[nextStage][localIndexOfNextStage], localCompetitor)
            }

            /* Put object updated in firebase */
            await updateASwitchingFromChamp(this.state.champId, this.state.chave.toString(), localSwitching);
            /* Build score */
            await this.buildScore(competitor.__key);

            await this.setState({ loading: false });

        } else if (this.state.switchingOrRotation === 'rotation') {

            /* Get and Set in a variable of the all switching infos */
            let localRotation = await getARotationFromChamp(this.state.champId, this.state.chave.toString());

            /* Update the local winner */
            if (index > 3) {
                localRotation['competitors'][keyWinner]['hasWon'] = true
                localRotation['competitors'][keyWinner]['score'] = 9
            } else {
                localRotation['competitors'][keyWinner]['hasWon'] = true
            }

            /* Update the local lose */
            if (index > 3) {
                localRotation['competitors'][keyLose]['hasWon'] = false
                localRotation['competitors'][keyLose]['lostTo'] = competitor.__key
                localRotation['competitors'][keyLose]['score'] = 3
            } else {
                localRotation['competitors'][keyLose]['hasWon'] = false
                localRotation['competitors'][keyLose]['lostTo'] = competitor.__key
            }

            /* Score the third place */
            if (index === 2 || index === 3) {
                localRotation['competitors'][keyLose]['score'] = 1
            }

            /* Send winner to the next stage */
            /* First: Create a win competitor with the basic infos */
            let localCompetitorW = {
                __key: competitor.__key,
                apto: competitor.apto,
                equipe: competitor.equipe,
                faixa: competitor.faixa,
                idade: competitor.idade,
                nome: competitor.nome,
                peso: competitor.peso,
                pesoQtd: competitor.pesoQtd,
                sexo: competitor.sexo,
                wasDeleted: competitor.wasDeleted
            }

            /* Second: Create a lose competitor with the basic infos */
            let localIndexOfLose = ''
            if (index % 2 === 0)
                localIndexOfLose = index + 1
            else
                localIndexOfLose = index - 1
            let localCompetitorL = {
                __key: localRotation['competitors'][localIndexOfLose].__key,
                apto: localRotation['competitors'][localIndexOfLose].apto,
                equipe: localRotation['competitors'][localIndexOfLose].equipe,
                faixa: localRotation['competitors'][localIndexOfLose].faixa,
                idade: localRotation['competitors'][localIndexOfLose].idade,
                nome: localRotation['competitors'][localIndexOfLose].nome,
                peso: localRotation['competitors'][localIndexOfLose].peso,
                pesoQtd: localRotation['competitors'][localIndexOfLose].pesoQtd,
                sexo: localRotation['competitors'][localIndexOfLose].sexo,
                wasDeleted: localRotation['competitors'][localIndexOfLose].wasDeleted
            }

            /* Third: Push competitors in next stage */
            if (index < 2) {
                localRotation['competitors'][4] = localCompetitorW
                localRotation['competitors'][3] = localCompetitorL

            } else if (index < 4) {
                localRotation['competitors'][5] = localCompetitorW

            } else {
                /* Build score */
                await this.buildScore()
            }

            /* Put object updated in firebase */
            await updateARotationFromChamp(this.state.champId, this.state.chave.toString(), localRotation);
        }
    }

    /**
     * Methods to build score of teams and competitor
     */
    buildScore = async (keyOfWinner) => {
        let localArrayOfTeamsScored = []

        if (this.state.switchingOrRotation === 'switching') {

            /* Score competitors and teams */
            let localSwitching = await getASwitchingFromChamp(this.state.champId, this.state.chave.toString());

            /* Score third place */
            let localCompetitor, localArrayOfSemiFinals = []
            localSwitching['semiFinals'].forEach(competitor => {
                localCompetitor = competitor
                localCompetitor.score = 0
                if (competitor.lostTo === keyOfWinner) {
                    localCompetitor.score = 1
                }
                localArrayOfSemiFinals.push(localCompetitor)
            })

            localSwitching['semiFinals'] = localArrayOfSemiFinals

            /* Get who won in final and semifinals and score them */
            localSwitching['final'].forEach(competitor => {
                localArrayOfTeamsScored.push({ team: competitor.equipe, score: competitor.score })
            })
            localSwitching['semiFinals'].forEach(competitor => {
                if (competitor.score || competitor.score !== 0)
                    localArrayOfTeamsScored.push({ team: competitor.equipe, score: competitor.score })
            })

            /* Put score in array of team */
            let finalArrayOfTeamScored = []

            for (let j = 0; j < localSwitching.arrayOfTeams.length; j++) {
                finalArrayOfTeamScored.push(localSwitching.arrayOfTeams[j])
                let sumOfScore = 0
                for (let i = 0; i < localArrayOfTeamsScored.length; i++) {
                    if (localArrayOfTeamsScored[i].team === localSwitching.arrayOfTeams[j].team) {
                        sumOfScore += localArrayOfTeamsScored[i].score
                    }
                }
                finalArrayOfTeamScored[j].score = sumOfScore
            }

            let localArrayToPush = {
                arrayOfTeams: finalArrayOfTeamScored,
                semiFinals: localSwitching.semiFinals
            }

            /* Push array of teams in firebase */
            await updateASwitchingFromChamp(this.state.champId, this.state.chave.toString(), localArrayToPush);

        }
    }

    /**
     * Cron Methods
     */
    /* Add one minute to cron */
    plusCron = () => {
        let localMin = this.state.cronMin
        if (localMin < 10) {
            localMin += 1
            this.setState({ cronMin: localMin })
        }
    }

    /* Remove one minute to cron */
    lessCron = () => {
        let localMin = this.state.cronMin
        if (localMin > 0) {
            localMin -= 1
            this.setState({ cronMin: localMin })
        }
    }

    /* Start regressive count */
    startStopCron = () => {
        let localSeg = this.state.cronSeg
        let localMin = this.state.cronMin

        if (!(localSeg === 0 && localMin === 0)) {
            /* Check if clicked to start */
            if (this.state.startCron) {
                let cron = setInterval(() => {
                    if (localSeg !== 0)
                        localSeg -= 1
                    else {
                        localSeg = 59
                        localMin -= 1
                    }

                    this.setState({ cronSeg: localSeg, cronMin: localMin })

                    /* Stop cron when end counting */
                    if (localSeg === 0 && localMin === 0) {
                        clearInterval(this.state.cronId)
                        this.setState({ startCron: !this.state.startCron })
                    }

                }, 1000)

                this.setState({ cronId: cron })
            }

            /* Check if clicked to stop */
            else {
                clearInterval(this.state.cronId)
            }

            this.setState({ startCron: !this.state.startCron })
        }
    }

    /* Zero time */
    zeroCron = () => {
        clearInterval(this.state.cronId)
        this.setState({
            cronMin: 0,
            cronSeg: 0,
            startCron: true
        })
    }

    /**
     * Finilized a confrontation
     */
    endConfrontationWinner01 = (e) => {
        /* Stop cron */
        if (!this.state.startCron)
            this.startStopCron()

        let localCompetitor01 = this.state.competitor01
        let localCompetitor02 = this.state.competitor02

        localCompetitor01['hasFinalized'] = (e.target.checked ? true : false)
        localCompetitor02['hasFinalized'] = false

        this.setState({
            competitor01: localCompetitor01,
            competitor02: localCompetitor02,
        })
    }

    endConfrontationWinner02 = (e) => {
        /* Stop cron */
        if (!this.state.startCron)
            this.startStopCron()

        let localCompetitor01 = this.state.competitor01
        let localCompetitor02 = this.state.competitor02

        localCompetitor01['hasFinalized'] = false
        localCompetitor02['hasFinalized'] = (e.target.checked ? true : false)

        this.setState({
            competitor01: localCompetitor01,
            competitor02: localCompetitor02,
        })
    }

    render() {
        if (this.state.pageToGo === 'confrontation') {
            return <Redirect to={{ pathname: '/home/champs/' + this.props.location.state.__key + '/confrontation/' + this.state.chave, state: { __key: this.props.location.state.__key, switchingId: this.state.chave, isScoreMan: true } }} />
        }

        if (this.state.pageToGo === 'rotation') {
            return <Redirect to={{ pathname: '/home/champs/' + this.props.location.state.__key + '/rotation/' + this.state.chave, state: { __key: this.props.location.state.__key, rotationId: this.state.chave, isScoreMan: true } }} />
        }

        return (
            <ScoreboardView
                loading={this.state.loading}
                loadingSave={this.state.loadingSave}
                chave={this.state.chave}
                stage={this.state.stage}
                competitor01={this.state.competitor01}
                competitor02={this.state.competitor02}
                cronMin={this.state.cronMin}
                cronSeg={this.state.cronSeg}
                champObject={this.state.champObject}
                champId={this.state.champId}
                switchingOrRotation={this.state.switchingOrRotation}
                idOfSwitching={this.state.idOfSwitching}

                endConfrontationWinner01={e => this.endConfrontationWinner01(e)}
                endConfrontationWinner02={e => this.endConfrontationWinner02(e)}
                plusCron={() => this.plusCron()}
                lessCron={() => this.lessCron()}
                zeroCron={() => this.zeroCron()}
                startStopCron={() => this.startStopCron()}
                scoreCompetitor={(a, b, c) => this.scoreCompetitor(a, b, c)}
                saveScore={() => this.saveScore()}
                //goBackToConfrontations={() => this.goBackToConfrontations()}
                invertCompetitor={() => this.invertCompetitor()}
            />
        )
    }
}

export default Scoreboard